function ok(data) {
  return Promise.resolve({ success: true, data })
}

// admin url
export function getLanguageList() {
  return ok([
    {
      code: 'zh',
      name: '中文',
      langData: []
    },
    {
      code: 'en',
      name: 'English',
      langData: []
    }
  ])
}
